// extracted by mini-css-extract-plugin
module.exports = {"icon":"Item_icon__1IKPn"};